import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './cons-type-product-nature.reducer';

export const ConsTypeProductNatureDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const [loadModal, setLoadModal] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
    setLoadModal(true);
  }, []);

  const consTypeProductNatureEntity = useAppSelector(state => state.consTypeProductNature.entity);
  const updateSuccess = useAppSelector(state => state.consTypeProductNature.updateSuccess);

  const handleClose = () => {
    props.history.push('/cons-type-product-nature');
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity(consTypeProductNatureEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="consTypeProductNatureDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="almobadaraMasterDataApp.consTypeProductNature.delete.question">
        <Translate
          contentKey="almobadaraMasterDataApp.consTypeProductNature.delete.question"
          interpolate={{ id: consTypeProductNatureEntity.id }}
        >
          Are you sure you want to delete this ConsTypeProductNature?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-consTypeProductNature" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Archive</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConsTypeProductNatureDeleteDialog;
